// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__xUYH-","inner":"Form_inner__2ESru","range":"Form_range__18QuS","name":"Form_name__LVs1w","actions":"Form_actions__3Po41"};